import {RouteInfo} from "../../route/RouteHelper";

export const sideBarListItems = [
    {
        info: RouteInfo.Dashboard,
    },
    {
        info: RouteInfo.union,
    },
    {
        info: RouteInfo.CashInfo,
    },
    {
        info: RouteInfo.Group,
        child: [
            {
                info: RouteInfo.CashGroups,
            }, {
                info: RouteInfo.CashGroupsReport,
            },
        ]
    },
    {
        info: RouteInfo.CashUsers,
    },
    {
        info: RouteInfo.Account,
        child: [
            {
                info: RouteInfo.ListOfAccounts
            },
            {
                info: RouteInfo.Transactions
            },
            {
                info: RouteInfo.Checkout
            },
        ]
    },
    {
        info: RouteInfo.Loin,
        child: [
            {
                info: RouteInfo.LoinList
            },
            {
                info: RouteInfo.Installments
            },
            {
                info: RouteInfo.LoinRequest
            },
        ]
    },
    {
        info: RouteInfo.PaymentTransaction
    },
    {
        info: RouteInfo.CashTransactions,
        child: [
            {
                info: RouteInfo.CashTransactionsList,
            },
            {
                info: RouteInfo.CostCategoryManager,
            },
            {
                info: RouteInfo.TagsManager,
            },
        ]
    },

    {
        info: RouteInfo.Feedback,
    },
    /*{
        info: RouteInfo.Profile,
    },*/
    {
        info: RouteInfo.Election,
    },
    {
        info: RouteInfo.OtherPayments,
    },
]
